var map = {
	"./slide1.png": "7b04",
	"./slide2.png": "7680",
	"./slide3.png": "29db",
	"./slide4.png": "3a63",
	"./slide5.png": "0538",
	"./slide6.png": "f145",
	"./slide7.png": "1d53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c36b";